import { cn } from '@/lib/utils/cn';

const OPERATOR_STYLES: Record<string, string> = {
  ZAIN:     'bg-rose-50 text-rose-700 ring-1 ring-rose-200 dark:bg-rose-500/15 dark:text-rose-300 dark:ring-rose-500/20',
  ORANGE:   'bg-amber-50 text-amber-700 ring-1 ring-amber-200 dark:bg-amber-500/15 dark:text-amber-300 dark:ring-amber-500/20',
  UMNIAH:   'bg-indigo-50 text-indigo-700 ring-1 ring-indigo-200 dark:bg-indigo-500/15 dark:text-indigo-300 dark:ring-indigo-500/20',
  STC:      'bg-primary-50 text-primary-700 ring-1 ring-primary-200 dark:bg-primary-500/15 dark:text-primary-300 dark:ring-primary-500/20',
  MOBILY:   'bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200 dark:bg-emerald-500/15 dark:text-emerald-300 dark:ring-emerald-500/20',
  ETISALAT: 'bg-sky-50 text-sky-700 ring-1 ring-sky-200 dark:bg-sky-500/15 dark:text-sky-300 dark:ring-sky-500/20',
  DU:       'bg-violet-50 text-violet-700 ring-1 ring-violet-200 dark:bg-violet-500/15 dark:text-violet-300 dark:ring-violet-500/20',
  VODAFONE: 'bg-red-50 text-red-700 ring-1 ring-red-200 dark:bg-red-500/15 dark:text-red-300 dark:ring-red-500/20',
};

const FALLBACK = 'bg-surface-subtle text-fg-muted ring-1 ring-border';

interface OperatorBadgeProps {
  operator: string | null | undefined;
  className?: string;
}

export function OperatorBadge({ operator, className }: OperatorBadgeProps) {
  if (!operator) {
    return <span className="text-fg-subtle">—</span>;
  }
  const key = operator.toUpperCase();
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-md px-2 py-0.5 text-[11px] font-medium leading-4',
        OPERATOR_STYLES[key] ?? FALLBACK,
        className,
      )}
    >
      {operator}
    </span>
  );
}
